import { formatCurrency } from "@angular/common";
import { IgxSummaryResult } from '@infragistics/igniteui-angular/core';
import { IgxNumberSummaryOperand } from '@infragistics/igniteui-angular/grids/core';
import { GridFormatService } from "../../../services";

export class Summary extends IgxNumberSummaryOperand
{
    static gridFormatService: GridFormatService;

    public operate(columnData: any[], allGridData = [], fieldName?, groupRecord?: any): IgxSummaryResult[]
    {
        let summaryResult: number = 0;
        if (groupRecord)
        {
            const groupedSummary = groupRecord.records.reduce((total, x) =>
            {
                total += +x[fieldName];
                return total;
            }, 0);

            let scale: number;
            const digitsInfo = groupRecord.column.grid.columns.find(c => c.field === fieldName).pipeArgs.digitsInfo;
            if (digitsInfo)
                scale = digitsInfo.split("-")[1];
            summaryResult = Summary.gridFormatService.summaryFormatter(groupedSummary, scale);
        }
        else
            summaryResult = allGridData.length === 0 || !allGridData[0][`total.${fieldName}`] ? 0 : allGridData[0][`total.${fieldName}`];

        return [{
            key: "total",
            label: "Total",
            summaryResult: summaryResult,
        },];
    }
}

export class CurrencySummary extends IgxNumberSummaryOperand
{
    static gridFormatService: GridFormatService;

    public operate(columnData: any[], allGridData = [], fieldName?, groupRecord?: any): IgxSummaryResult[]
    {
        let summaryResult: string = "";
        if (groupRecord)
        {
            const groupedSummary = groupRecord.records.reduce((total, x) =>
            {
                total += +(x[fieldName].toString()
                    .replace("$", "")
                    .replace(/,/g, ""));
                return total;
            }, 0);

            let scale: number;
            const digitsInfo = groupRecord.column.grid.columns.find(c => c.field === fieldName).pipeArgs.digitsInfo;
            if (digitsInfo)
                scale = digitsInfo.split("-")[1];
            summaryResult = formatCurrency(CurrencySummary.gridFormatService.summaryFormatter(groupedSummary, scale)
                .replace("$", "")
                .replace(/,/g, ""), "en-US", "$");
        }
        else
            summaryResult = formatCurrency(
                allGridData.length === 0 || !allGridData[0][`total.${fieldName}`]
                    ? 0
                    : + allGridData[0][`total.${fieldName}`].replace("$", "").replace(/,/g, ""),
                "en-US",
                "$"
            );

        return [{
            key: "total",
            label: "Total",
            summaryResult: summaryResult,
        }];
    }
}

export class Average extends IgxNumberSummaryOperand
{
    public operate(columnData: any[], allGridData = [], fieldName?): IgxSummaryResult[]
    {
        return [{
            key: "avg",
            label: "Average",
            summaryResult: allGridData.length === 0 || !allGridData[0][`average.${fieldName}`] ? 0 : allGridData[0][`average.${fieldName}`],
        },];
    }
}

export class CurrencyAverage extends IgxNumberSummaryOperand
{
    public operate(columnData: any[], allGridData = [], fieldName?): IgxSummaryResult[]
    {
        return [{
            key: "avg",
            label: "Average",
            summaryResult: formatCurrency(
                allGridData.length === 0 || !allGridData[0][`average.${fieldName}`]
                    ? 0
                    : + allGridData[0][`average.${fieldName}`],
                "en-US",
                "$"
            ),
        },];
    }
}
